import request from "@/utils/request";

function brandEvaluationCompareRegionList(data) {   // 对比区域列表
    return request({
        url: '/brandEvaluation/compareRegionList',
        method: 'POST',
        data
    })
}

function brandEvaluationBrandComprehensiveIndex(data) {   // 品牌综合指数
    return request({
        url: '/brandEvaluation/brandComprehensiveIndex',
        method: 'POST',
        data
    })
}

function brandEvaluationGetBrandIndex(data) {    // 品牌知名度,质量，获得感，个性，忠诚读指数
    return request({
        url: '/brandEvaluation/getBrandIndex',
        method: 'POST',
        data
    })
}

function brandEvaluationGetBrandDimensionRank(data) {       //品牌维度排名
    return request({
        url: '/brandEvaluation/getBrandDimensionRank',
        method: 'POST',
        data
    })
}

function brandEvaluationGetBrandKeywordsCloud(data) {   //热议品牌话题
    return request({
        url: '/brandEvaluation/getBrandKeywordsCloud',
        method: 'POST',
        data
    })
}

export {
    brandEvaluationCompareRegionList,
    brandEvaluationBrandComprehensiveIndex,
    brandEvaluationGetBrandIndex,
    brandEvaluationGetBrandDimensionRank,
    brandEvaluationGetBrandKeywordsCloud
};
